<div>
  <div class="breadcrumb-block">
      <FlashMessage></FlashMessage>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name:'business-dashboard'}">Home</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Pending invite list</li>
      </ol>
    </nav>
  </div>
  <div class="manage-package-block">
    <div class="white-box">
      <div class="table-title pb-0">
          <h5><i class="fas fa-hourglass-half"></i> Pending invite list</h5>
      </div>
<hr>
      <div class="manage-user-block">
        <div class="content-block">
          <div class="table-container">
            <div class="table-responsive">
              <table class="table" id="example">
                <thead class="table-light-bg">
                  <tr>
                    <th scope="col">
                      Email <i class="fas fa-chevron-down"></i>
                    </th>
                    <th scope="col">
                     Send Date <i class="fas fa-chevron-down"></i>
                    </th>
                    <!-- <th scope="col">
                      Status
                      <i class="fas fa-chevron-down"></i>
                    </th> -->

                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="PendingList" v-for="(invite, index) in PendingList" :key="index">
                    <td v-if="invite.user">{{invite.user.email}}</td>
                    <td v-if="invite.invited_date">{{invite.invited_date}}</td>
                    <!-- <td>
                        <span class="badge badge-secondary">Pending</span>
                    </td> -->
                    <td>
                      <div class="inline-button-block">
                        <a
                          class="btn default-btn green"
                          href="#"
                          @click.prevent="resendInvite(invite, index)"
                        > Resend
                        <spinner v-if="invite.IsActive" :loading="invite.IsActive"></spinner>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <div v-if="!PendingList" class="empty-data">
                    <p>
                        No Pending List
                    </p>
                </div>
                </tbody>
              </table>
            </div>
          </div>
        <!-- <hr> -->
        <!-- <Pager @onPaging="onPaging" :pager="paging"></Pager> -->
        </div>
      </div>
    </div>
  </div>
</div>
